import { Component, Input } from '@angular/core';
import { DescriptionQuestionV3 } from '../../../classes/question-description';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-description-v3',
  templateUrl: './input-description.component.html',
  styleUrls: ['./input-description.component.scss'],
  standalone: false
})
export class InputDescriptionComponentV3 extends QuestionBaseV3ComponentDirective {
  @Input() question: DescriptionQuestionV3;
  @Input() color: string;

  get value() {
    return this.formGroup.get(this.question.key).value;
  }
}
